import moment from 'moment';

export default class Documents {
  constructor({
    id,
    rowNum,
    documentUrl,
    documentType,
    uploadedByName,
    createdAt,
    regions,
    clusters,
    storeids,
    formats,
    startDate,
    endDate,
    active,
    title,
    description,
    remarks,
    completeRemarks
  }) {
    this.id = id || '';
    this.rowNum = rowNum || '';
    this.storeids = storeids || '';
    this.uploadedByName = uploadedByName || '';
    this.title = title || '';
    this.description = description || '';
    this.startDate = startDate ? moment(startDate).format('LL') : null;
    this.endDate = endDate ? moment(endDate).format('LL') : null;
    this.documentType = documentType || '';
    this.documentUrl = documentUrl || '';
    this.createdAt = createdAt ? moment(createdAt).format('LL') : null;
    this.regions = regions || '';
    this.clusters = clusters || '';
    this.formats = formats || '';
    this.active = active ? 'True' : 'False';
    this.remarks = remarks || '';
    this.completeRemarks = completeRemarks || '';
  }
}
